import { initials } from '@/lib/format';

const PALETTE = [
  'from-accent-500 to-accent-300',
  'from-accent-300 to-accent-400',
  'from-accent-400 to-accent-200',
  'from-accent-700 to-accent-600',
];

export function Avatar({
  name,
  src,
  size = 40,
}: { name: string; src?: string; size?: number }): JSX.Element {
  const i = Math.abs(hash(name)) % PALETTE.length;
  return (
    <div
      className={`relative inline-flex shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br ${PALETTE[i]} text-white font-semibold`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }}
    >
      {src ? (
        // eslint-disable-next-line jsx-a11y/img-redundant-alt
        <img src={src} alt={name} className="absolute inset-0 h-full w-full rounded-2xl object-cover" />
      ) : (
        <span>{initials(name) || '·'}</span>
      )}
    </div>
  );
}

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h << 5) - h + s.charCodeAt(i);
  return h;
}
